import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export type RobotType = 'otter' | 'inform' | 'marty';

@Component({
  selector: 'bt-robot-loader',
  templateUrl: './robot-loader.component.html',
  styleUrls: ['./robot-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class RobotLoaderComponent {
  @Input() isLoading = false;
  @Input() message = 'Loading...';
  @Input() opaque = false;
  @Input() robot: RobotType = 'otter';

  shelves = Array(3).fill(0);
}
